/* sci-pages.js (WS-SCIENCE) — small, vanilla, deferred. Filters + tap-to-expand cards, dose-by-weight, "which formula?", stack check,
   diagram/timeline hooks. Motion itself (reveal, tabs, steps, scrub, count) is owned by plentum-motion.js via data-pm-* attributes. */
(function () {
  'use strict';
  if (window.__sci) return; window.__sci = 1;
  var d = document;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || d).querySelectorAll(s)); }
  function money(n) { return '$' + n.toFixed(2); }
  function jsonOf(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* ---------- ingredient library ---------- */
  function lib(root) {
    var cards = $$('.sci-ing', root), st = { f: 'all', n: 'all', q: '' };
    var count = $('[data-sci-count]', root), empty = $('[data-sci-empty]', root), q = $('[data-sci-q]', root);
    function toggle(card, open) {
      var b = $('.sci-ing__btn', card), on = open === undefined ? !card.classList.contains('is-open') : open;
      card.classList.toggle('is-open', on); b.setAttribute('aria-expanded', String(on));
      var p = $('.sci-ing__panel', card); if (p) p.setAttribute('aria-hidden', String(!on));
    }
    function apply() {
      var shown = 0, term = st.q.trim().toLowerCase();
      cards.forEach(function (c) {
        var okF = st.f === 'all' || (' ' + c.getAttribute('data-formulas') + ' ').indexOf(' ' + st.f + ' ') > -1;
        var okN = st.n === 'all' || (' ' + c.getAttribute('data-needs') + ' ').indexOf(' ' + st.n + ' ') > -1;
        var okQ = !term || (c.getAttribute('data-search') || '').indexOf(term) > -1;
        var on = okF && okN && okQ; c.hidden = !on; if (on) shown++;
      });
      if (count) count.innerHTML = 'Showing <b>' + shown + '</b> of ' + cards.length + ' ingredients';
      if (empty) empty.classList.toggle('is-on', !shown);
      /* dose lines: when a formula is picked, put that formula's dose first and dim the rest */
      cards.forEach(function (c) {
        $$('.sci-doses li', c).forEach(function (li) {
          li.style.opacity = (st.f === 'all' || li.getAttribute('data-f') === st.f) ? '' : '.5';
        });
      });
    }
    function setGroup(attr, val) {
      $$('[data-sci-' + attr + ']', root).forEach(function (b) { if (b.tagName === 'BUTTON') b.setAttribute('aria-pressed', String(b.getAttribute('data-sci-' + attr) === val)); });
      st[attr === 'f' ? 'f' : 'n'] = val; apply();
    }
    $$('[data-sci-f]', root).forEach(function (b) { b.addEventListener('click', function () { setGroup('f', b.getAttribute('data-sci-f')); }); });
    $$('[data-sci-n]', root).forEach(function (b) { b.addEventListener('click', function () { setGroup('n', b.getAttribute('data-sci-n')); }); });
    if (q) q.addEventListener('input', function () { st.q = q.value; apply(); });
    $$('[data-sci-reset]', root).forEach(function (b) { b.addEventListener('click', function () { if (q) q.value = ''; st.q = ''; setGroup('f', 'all'); setGroup('n', 'all'); }); });
    cards.forEach(function (c) { $('.sci-ing__btn', c).addEventListener('click', function () { toggle(c); }); });
    /* deep links: ?formula=gr&need=gut  ·  #ing-colostrum */
    try {
      var u = new URL(location.href), f = u.searchParams.get('formula'), n = u.searchParams.get('need');
      if (f && $('[data-sci-f="' + f + '"]', root)) setGroup('f', f);
      if (n && $('[data-sci-n="' + n + '"]', root)) setGroup('n', n);
    } catch (e) {}
    function hash() {
      var h = location.hash.replace('#', ''); if (h.indexOf('ing-') !== 0) return;
      var c = d.getElementById(h); if (!c) return;
      if (c.hidden) { setGroup('f', 'all'); setGroup('n', 'all'); }
      toggle(c, true); setTimeout(function () { c.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 60);
    }
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#ing-"]');
      if (a) setTimeout(hash, 0);
    });
    apply(); hash(); addEventListener('hashchange', hash);
  }

  /* ---------- dosing ---------- */
  function sachetsFor(key, w) {
    if (key === 'mc') return w < 20 ? 1 : w <= 50 ? 2 : 3;
    return w <= 25 ? 1 : w <= 50 ? 2 : w <= 75 ? 3 : 4;
  }
  function tierFor(key, w) {
    if (key === 'mc') return w < 20 ? 0 : w <= 50 ? 1 : 2;
    return w <= 25 ? 0 : w <= 50 ? 1 : w <= 75 ? 2 : 3;
  }
  function dose(root) {
    var data = jsonOf($('[data-sci-json]', root)) || {}, range = $('input[type=range]', root), out = $('[data-sci-wt]', root);
    var unit = 'lb', kg = $('[data-sci-kg]', root);
    function render() {
      var w = +range.value, lbs = unit === 'kg' ? Math.round(w * 2.2046) : w;
      out.textContent = w;
      $$('[data-sci-unit]', root).forEach(function (e) { e.textContent = unit; });
      $$('[data-sci-card]', root).forEach(function (c) {
        var k = c.getAttribute('data-sci-card'), n = sachetsFor(k, lbs), t = tierFor(k, lbs), f = data[k] || {};
        $('[data-sci-n]', c).textContent = n;
        $('[data-sci-g]', c).textContent = (n * 2) + ' g a day';
        var pd = f.perDay && f.perDay[t]; $('[data-sci-pd]', c).textContent = pd ? money(pd) + ' a day' : '';
        var tn = f.tiers && f.tiers[t]; $('[data-sci-tier]', c).textContent = tn ? 'Size: ' + tn : '';
        $$('.pm-icon', $('.sci-sachets', c)).forEach(function (ic, i) { ic.classList.toggle('off', i >= n); });
      });
    }
    range.addEventListener('input', render);
    if (kg) kg.addEventListener('click', function () {
      unit = unit === 'lb' ? 'kg' : 'lb';
      var lbs = +range.value; var nv = unit === 'kg' ? Math.round(lbs / 2.2046) : Math.round(lbs * 2.2046);
      range.min = unit === 'kg' ? 2 : 5; range.max = unit === 'kg' ? 68 : 150; range.value = nv;
      kg.setAttribute('aria-pressed', String(unit === 'kg')); kg.textContent = unit === 'kg' ? 'Show in lb' : 'Show in kg'; render();
    });
    render();
  }

  /* ---------- which formula ---------- */
  function which(root) {
    var opts = $$('[data-pick]', root), res = $$('[data-res]', root), ph = $('[data-sci-ph]', root);
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        opts.forEach(function (x) { x.setAttribute('aria-pressed', String(x === o)); });
        var k = o.getAttribute('data-pick');
        res.forEach(function (r) { r.hidden = r.getAttribute('data-res') !== k; });
        if (ph) ph.hidden = true;
        if (matchMedia('(max-width:979px)').matches) { var t = $('[data-res="' + k + '"]', root); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
      });
    });
  }

  /* ---------- stack check ---------- */
  function stack(root) {
    var data = jsonOf($('[data-sci-json]', root)) || {}, chips = $$('[data-sf]', root), sel = {}, wt = $('input[type=number]', root), out = $('[data-sci-out]', root);
    var names = data.names || {};
    function render() {
      var keys = Object.keys(sel).filter(function (k) { return sel[k]; });
      if (keys.length < 2) { out.innerHTML = '<p class="sci-small">Pick two or more supplements to see which actives repeat and what the day looks like.</p>'; return; }
      var rows = (data.overlaps || []).filter(function (o) { return keys.filter(function (k) { return o.doses[k]; }).length > 1; });
      var h = '';
      if (rows.length) {
        h += '<table class="sci-ovr"><thead><tr><th>Repeated active</th><th>Where it appears (per sachet)</th></tr></thead><tbody>';
        rows.forEach(function (o) {
          var parts = keys.filter(function (k) { return o.doses[k]; }).map(function (k) { return names[k] + ': <b>' + o.doses[k] + '</b>'; });
          h += '<tr><td>' + o.name + '</td><td>' + parts.join('<br>') + (o.sum ? '<br><span class="sci-small">If you give one sachet of each: ' + o.sum(keys) + '</span>' : '') + '</td></tr>';
        });
        h += '</tbody></table>';
      } else { h += '<div class="sci-okline">No active is repeated between these supplements on the labels.</div>'; }
      var w = Math.max(5, +wt.value || 40), tot = 0, cost = 0, lines = [];
      keys.forEach(function (k) {
        var n = sachetsFor(k, w), t = tierFor(k, w), f = data.formulas[k], pd = f.perDay[t] || 0; tot += n; cost += pd;
        lines.push(names[k] + ': ' + n + ' a day');
      });
      h += '<p class="sci-small" style="margin-top:14px"><b>For a ' + w + ' lb dog:</b> ' + lines.join(' · ') + ' = ' + tot + ' sachets (' + (tot * 2) + ' g) and about ' + money(cost) + ' a day at one-time box prices. Each supplement is dosed by weight on its own.</p>';
      out.innerHTML = h;
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { var k = c.getAttribute('data-sf'); sel[k] = !sel[k]; c.setAttribute('aria-pressed', String(!!sel[k])); render(); }); });
    if (wt) wt.addEventListener('input', render);
    /* overlaps: attach summing helpers (same unit only) */
    (data.overlaps || []).forEach(function (o) {
      if (o.sumKey) o.sum = function (keys) {
        var t = 0, unit = o.unit || 'mg', ks = keys.filter(function (k) { return o.nums && o.nums[k] != null; });
        ks.forEach(function (k) { t += o.nums[k]; }); return ks.length > 1 ? t + ' ' + unit + ' together' : '';
      };
    });
    render();
  }

  /* ---------- diagram + timeline hooks ---------- */
  function diagram(root) {
    var svg = $('.sci-svg', root);
    if (!svg) return;
    var upto = [0, 1, 2, 5];
    function paint(i) {
      var m = upto[Math.min(i, 3)];
      $$('g[data-s]', svg).forEach(function (g) { g.classList.toggle('on', +g.getAttribute('data-s') <= m); });
      $$('.lnk', svg).forEach(function (l) { l.classList.toggle('hot', +l.getAttribute('data-l') < m); });
    }
    root.addEventListener('pm:step', function (e) { paint(e.detail && e.detail.index || 0); });
    paint(0);
  }
  function timeline(root) {
    var rail = $$('.sci-tl__rail i', root);
    function paint(w) { rail.forEach(function (r, i) { r.classList.toggle('on', i < w); }); }
    root.addEventListener('pm:week', function (e) { paint(e.detail && e.detail.week || 1); });
    paint(1);
  }

  function init(c) {
    c = c || d;
    $$('[data-sci-lib]', c).forEach(function (e) { if (!e._sci) { e._sci = 1; lib(e); } });
    $$('[data-sci-dose]', c).forEach(function (e) { if (!e._sci) { e._sci = 1; dose(e); } });
    $$('[data-sci-which]', c).forEach(function (e) { if (!e._sci) { e._sci = 1; which(e); } });
    $$('[data-sci-stack]', c).forEach(function (e) { if (!e._sci) { e._sci = 1; stack(e); } });
    $$('[data-sci-diagram]', c).forEach(function (e) { if (!e._sci) { e._sci = 1; diagram(e); } });
    $$('[data-sci-timeline]', c).forEach(function (e) { if (!e._sci) { e._sci = 1; timeline(e); } });
  }
  init();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
